import { render, staticRenderFns } from "./waitModal.vue?vue&type=template&id=1ad8a253"
import script from "./waitModal.vue?vue&type=script&lang=js"
export * from "./waitModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports